export default "dist/images/block-header-center-overlay.4119753.png";